import { Expose } from "class-transformer";
import { IsBoolean, IsOptional, IsString } from "class-validator";

export class AirlineEditAdd {
  @IsString()
  @Expose()
  @IsOptional()
  icaoCode!: string | null;

  @IsString()
  @Expose()
  @IsOptional()
  iataCode!: string | null;

  @IsString()
  @Expose()
  name!: string;

  @IsString()
  @Expose()
  @IsOptional()
  numericCode!: string | null;

  @IsBoolean()
  @Expose()
  @IsOptional()
  isLowCost!: boolean;

  constructor() {
    this.icaoCode = "";
    this.iataCode = "";
    this.name = "";
    this.numericCode = "";
    this.isLowCost = false;
  }
}
